import React from 'react'
import ModeIcon from '@mui/icons-material/Mode';
import theme from '../../../theme';
import Typography from '../Typography';

interface Props{
  onClick:()=>void,
  modifyItem:string,
  style?:React.CSSProperties,
  isAdding?:boolean,
  isModifyPaymentMehodPress?:boolean
}

export default function ModifyBlock({onClick,modifyItem,style,isAdding,isModifyPaymentMehodPress}:Props) {
  return (
    <div  onClick={()=>!isModifyPaymentMehodPress?onClick():{}} className='flex items-center' style={{...style,cursor:"pointer",opacity:!isModifyPaymentMehodPress?1:0.3}}>
        <ModeIcon style={{fontSize:20,marginTop:theme.sizing.x1}} color="primary"/>
        <Typography colorVariant='primary' variant="label" className='mt-2 ms-1'>
        {isAdding?"Aggiungi":"Modifica"} {modifyItem}
        </Typography>
  </div>
  )
}
